import type { HTMLAttributes } from 'react';
import classNames from 'classnames';
import { Icon } from '@/components/atoms/Icon';

import styles from './index.module.scss';

interface GarageDetailsProps extends HTMLAttributes<HTMLDivElement> {
  readonly iconId: string;
  readonly text?: string;
}

export function GarageDetails({ iconId, text, className }: GarageDetailsProps): JSX.Element {
  return (
    <div className={classNames(GarageDetails.displayName, styles.GarageDetails, className)}>
      <Icon className={styles.GarageIcon} legacy={false} width={20} height={20} id={iconId} />
      <p className={styles.GarageText}>{text}</p>
    </div>
  );
}

GarageDetails.displayName = 'GarageDetails';
